import { API, crmServiceUrl } from '@labrav/common'

const getRecordByRecordId = (
  crmId: string,
  crmObjectName: string,
  recordId: string,
  fields?: string
) =>
  API.get(`${crmServiceUrl}/crms/${crmId}/${crmObjectName}/${recordId}`, {
    ...(fields != null && fields !== '' && { params: { fields } }),
  })

export interface LightningRecordData {
  labraOfferId: string
  recordType: string
  labraProductId: string
  labraReferralId?: string
  cloudProvider?: string
  labraAccountId?: string
}

export interface FetchLightningRecordParams {
  crmId: string
  objectAPIName: string
  recordId: string
  fields?: string
}

/**
 * Fetches the Salesforce record by ID and returns parsed fields for routing.
 * Does not perform navigation; caller is responsible for navigation logic.
 */
export const fetchLightningRecord =
  (params: FetchLightningRecordParams) =>
  async (): Promise<LightningRecordData | null> => {
    const { crmId, objectAPIName, recordId, fields } = params

    if (!crmId || !objectAPIName || !recordId) return null

    try {
      const res = await getRecordByRecordId(
        crmId,
        objectAPIName,
        recordId,
        fields
      )
      const data = res?.data ?? {}

      if (
        objectAPIName === 'LabraIo__Labra_AWS_Referral__c' ||
        objectAPIName === 'LabraIo__Labra_Microsoft_Referral__c'
      ) {
        const labraReferralId = data.LabraIo__Labra_Referral_Id__c
        if (!labraReferralId) return null
        return {
          labraOfferId: '',
          recordType: '',
          labraProductId: '',
          labraReferralId,
          cloudProvider:
            objectAPIName === 'LabraIo__Labra_Microsoft_Referral__c'
              ? 'azure'
              : 'aws',
          labraAccountId: data.LabraIo__Labra_Account_Id__c,
        }
      }

      const labraOfferId = data.LabraIo__Labra_Offer_Id__c
      const recordType = data.LabraIo__Record_Type__c
      const labraProductId =
        data['LabraIo__Labra_Product__r.LabraIo__Labra_Product_Id__c'] ?? ''

      const cloudProvider = data.LabraIo__Cloud_Provider__c
      const labraAccountId = data.LabraIo__Labra_Account_Id__c
      if (!labraOfferId || !recordType) return null

      return {
        labraOfferId,
        recordType,
        labraProductId,
        cloudProvider,
        labraAccountId,
      }
    } catch (err) {
      console.error('LightningRecordPage: getRecordByRecordId failed', err)
      return null
    }
  }
